import React from 'react'
import ReactTooltip from 'react-tooltip'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import UpdateAutoSubmissionStatus from './UpdateAutoSubmissionStatus'
import UpdateRegistrationMaxSlots from './UpdateRegistrationMaxSlots'
import CloseCampaign from './CloseCampaign'
import { CampaignState } from 'state/campaigns'
import { useSelector } from 'react-redux'
import { selectIsInternalUser } from 'state/profile'
import Restricted from 'components/Shared/Permission/Restricted'
import { CampaignManagement, CampaignStatusControl } from 'components/Shared/Permission/enums'

import Divider from 'components/Divider'
import IconButton from 'particles/Button/IconButton'

const PartiTooltip = styled.div`
    .box__tooltip {
        background: white;
        color: black;
        border-radius: 0.5em;
        font-size: 1em;
        border: 0.5px solid ${theme.newColors.neutral400};
    }
    .campaign__tooltip {
        opacity: 1 !important;
        min-width: 200px;
        padding: ${theme.spacing.xxs};
        pointer-events: auto !important;
        z-index: 999999;

        &.place-left {
            &:after {
                display: none;
            }
        }
    }
`

interface CampaignOptionsTooltipProps {
    campaign: CampaignState
    id: string
}

const CampaignOptionsTooltip: React.FC<CampaignOptionsTooltipProps> = ({ campaign, id }) => {
    const isInternalUser = useSelector(selectIsInternalUser)
    return (
        <PartiTooltip>
            <Restricted permissions={[CampaignManagement.LiveCampaignEditBriefs, CampaignStatusControl.CloseCampaign]}>
                <IconButton
                    icon="dotsThreeVertical"
                    size="xs"
                    form="icon"
                    color="neutral"
                    data-tip
                    data-for={`campaign-options-${campaign.uuid}-${id}`}
                    data-event="click"
                />
            </Restricted>

            <ReactTooltip
                id={`campaign-options-${campaign.uuid}-${id}`}
                place="left"
                effect="solid"
                globalEventOff="click"
                delayShow={0}
                className="box__tooltip campaign__tooltip"
            >
                <Restricted permissions={[CampaignManagement.LiveCampaignEditBriefs]}>
                    <UpdateAutoSubmissionStatus campaign={campaign} />
                </Restricted>

                {isInternalUser && (
                    <>
                        {campaign.registration_enable && (
                            <Restricted permissions={[CampaignManagement.LiveCampaignEditBriefs]}>
                                <Divider />
                                <UpdateRegistrationMaxSlots campaign={campaign} />
                            </Restricted>
                        )}
                        <Restricted permissions={[CampaignStatusControl.CloseCampaign]}>
                            <Divider />
                            <CloseCampaign campaign={campaign} />
                        </Restricted>
                    </>
                )}
            </ReactTooltip>
        </PartiTooltip>
    )
}

export default CampaignOptionsTooltip
